export default {
	title: 'रणनीतिक योजना',
	tabs: {
		general: {
			title: 'सामान्य'
		},
		filters: {
			title: 'दृश्य फ़िल्टर'
		},
		bot: {
			title: 'बुद्धिमत्ता'
		},
		export: {
			title: 'निर्यात'
		},
		display: {
			title: 'प्रदर्शन'
		}
	},
	filters: {
		responsible: {
			title: 'ज़िम्मेदार के अनुसार फ़िल्टर',
			placeholder: 'ज़िम्मेदार का नाम'
		},
		completion: {
			title: 'पूर्णता फ़िल्टर',
			not_started: 'शुरू नहीं',
			in_progress: 'प्रगति पर',
			completed: 'पूर्ण'
		},
		dates: {
			title: 'तिथि फ़िल्टर'
		},
		startOn: {
			title: 'प्रारंभ तिथि फ़िल्टर',
			undefined: 'कोई तिथि नहीं',
			past: 'बीता हुआ',
			ending_week: 'एक सप्ताह में शुरू',
			ending_month: 'एक महीने में शुरू',
			ending_quarter: 'एक तिमाही में शुरू',
			ending_year: 'एक वर्ष में शुरू'
		},
		endOn: {
			title: 'समाप्ति तिथि फ़िल्टर',
			undefined: 'कोई तिथि नहीं',
			done: 'पूर्ण',
			overdue: 'अतिदेय',
			ending_week: 'एक सप्ताह में समाप्त',
			ending_month: 'एक महीने में समाप्त',
			ending_quarter: 'एक तिमाही में समाप्त',
			ending_year: 'एक वर्ष में समाप्त'
		}
	},

	display: {
		sort: {
			title: 'शाखाओं का क्रम',
			startOn: 'आरंभ तिथि के अनुसार',
			name: 'नाम के अनुसार',
			manual: 'मैनुअल क्रम'
		}
	},
	all_icons: 'आइकन फ़िल्टर',
	no_icon: 'कोई आइकन नहीं',
	onboarding: {
		title: 'कार्य योजना समीक्षा',
		description:
			'जाँचें कि अक्ष और आइटम आपकी योजना की समझ से मेल खाते हैं।'
	}
};
